// see https://domgen.atlassian.net/browse/DGX-1947 for cases
export enum ModelQualification {
  Search = 'Search', // Case A
  Auto = 'Auto', // Case B
  ManualEntry = 'ManualEntry', // Case C
}
